import React from 'react';
import PropTypes from 'prop-types'

// Error boundaries are React components that catch JavaScript errors anywhere
// in their child component tree, log those errors, and display a fallback UI
// instead of the component tree that crashed.

// https://reactjs.org/docs/error-boundaries.html

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}
	static get propTypes() {
		return {
			silent: PropTypes.bool,
			children: PropTypes.node,
		};
	}

	static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch() {
		// We could log the error to an error reporting service
	}

	render() {
		if (this.state.hasError) {

			// render fallback UI - NON-CRITICAL ERROR
			// ex. <ErrorBoundary silent>...</ErrorBoundary>
			if (this.props.silent) {
				return null;
			}

			// render fallback UI - CRITICAL ERROR
			// ex. <ErrorBoundary>...</ErrorBoundary>
			return (
				<div className="errorBoundary" role="alert">
					<h1>Er is een fout opgetreden. Gelieve de pagina opnieuw te laden.</h1>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
